// extracted by mini-css-extract-plugin
export default {"main":"PageNav_main__cUw2V"};